import { Typography } from "antd";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import { useUpdateStatusRequestMoney } from "../../../api/send-money";
import { CustomButton } from "../../../components/button/buttonCustom";
import { ButtonTransparent } from "../../../components/button/buttonTransparent";
import { purposeOfRemittanceItemNames } from "../../../components/inputs/select/purposeOfRemittance.constants";
import { useNotification } from "../../../components/providers/notification/useNotification";
import PaymentStatus from "../../../types/paymentStatus.type";
import useResponsive from "../../../utils/hooks/useResponsive";
import StatusForm from "../../history/component/form/status-form";
import TextContent from "../../history/component/form/text-content";
import { Fiat } from "./form-transfer-props";

const DetailSuccess = ({ detailRequestMoney, setActionFutureDate }: { detailRequestMoney: any, setActionFutureDate: (value: boolean) => void }) => {
  const { open: openNotification } = useNotification();
  const navigate = useNavigate();
  const { isTablet } = useResponsive();

  const { mutate: updateSendMoney, isLoading: isLoadingUpdate } =
    useUpdateStatusRequestMoney({
      onSuccess: () => {
        const isFiat = Fiat.includes(detailRequestMoney?.paymentCurrency);
        navigate(
          `/history?tab=${isFiat ? 'fiat' : 'crypto'}&orderId=${detailRequestMoney?.id}&type=request-money`
        );
      },
      onError: (error: { message: string }) => {
        if (openNotification) {
          openNotification({
            key: "add_bank_account_failure",
            message: error?.message || "Something went wrong!",
            type: "error",
          });
        }
      },
    });

  const handlePaid = () => {
    updateSendMoney({
      id: detailRequestMoney?.id,
      isPaid: true,
    });
  };

  const handlePayLater = () => {
    setActionFutureDate(true);
  };

  const reasonStatus = () => {
    switch (detailRequestMoney.status?.current) {
      case PaymentStatus.PENDING:
        // return "To finalize your order, please complete the payment as instructed.";
        return "";
      case PaymentStatus.REJECTED:
        return detailRequestMoney.reason || "N/A";
      case PaymentStatus.POSTPONED:
        return detailRequestMoney.reason || "N/A";
      case PaymentStatus.FAILED:
        return detailRequestMoney.reason || "Something went wrong.";
      case PaymentStatus.APPROVED:
        return "This request was approved by the admin.";
      case PaymentStatus.CANCELLED:
        return "Request money order canceled successfully.";
      case PaymentStatus.COMPLETED:
        return "Request money has been completed. Check your portfolio for details.";
      default:
        return "";
    }
  };

  return (
    <div>
      <div className="form-history">
        <StatusForm
          title={`Request Money ${detailRequestMoney?.orderId}`}
          status={detailRequestMoney.status?.current}
          content={reasonStatus()}
        />
        <div className="modal-balance">
          <div className="value-balance">
            <Typography style={{ fontSize: 16, color: "white" }}>
              Total to pay
            </Typography>
            <Typography className="text-gradient">
              {detailRequestMoney?.amounts?.totalSendAmount}{" "}
              <Typography.Text
                className="text-gradient"
                style={{
                  fontSize: isTablet ? "20px" : "24px",
                }}
              >
                {detailRequestMoney?.paymentCurrency}
              </Typography.Text>
            </Typography>
          </div>
        </div>
        <div className="form-history-content">
          <TextContent
            label="Beneficiary Will Receive"
            value={`${detailRequestMoney?.amounts?.totalReceiveAmount} ${detailRequestMoney?.receiveCurrency}`}
            color="rgba(242, 138, 40, 1)"
          />
        </div>
        <div className="form-history-content border-top">
          <TextContent label="Payment Method" value="Provider" />
          <TextContent
            label="Provider"
            value={detailRequestMoney?.serviceProvider?.name}
            color="rgba(242, 138, 40, 1)"
          />
          <TextContent
            label="Currency"
            value={detailRequestMoney?.receiveCurrency}
            canCopy
          />
          {Fiat.includes(detailRequestMoney?.paymentCurrency) ? (
            <>
              <TextContent
                label="Provider Bank Name"
                value={detailRequestMoney?.serviceProvider?.providerBankName}
                canCopy
              />
              <TextContent
                label="Provider Bank SWIFT"
                value={detailRequestMoney?.serviceProvider?.providerBankSwift}
                canCopy
              />
              <TextContent
                label="Provider Bank Address"
                value={detailRequestMoney?.serviceProvider?.providerBankAddress}
                canCopy
              />
              <TextContent
                label="Provider Bank Account"
                value={detailRequestMoney?.serviceProvider?.providerBankAccount}
                canCopy
              />
            </>
          ) : (
            <>
              <TextContent
                label="Network"
                value={detailRequestMoney?.serviceProvider?.network}
                canCopy
              />
              <TextContent
                label="Provider Wallet Address"
                value={detailRequestMoney?.serviceProvider?.walletAddress}
                canCopy
              />
            </>
          )}
          <TextContent
            label="Reference Number"
            value={detailRequestMoney?.referenceNumber}
            canCopy
            color="rgba(242, 138, 40, 1)"
          />
          <TextContent
            label="Purpose of Remittance"
            value={detailRequestMoney?.purposeOfRemittance &&
              purposeOfRemittanceItemNames[
              detailRequestMoney?.purposeOfRemittance as keyof typeof purposeOfRemittanceItemNames
              ]
            }
          />
          {/* <TextContent
            label="Send Date"
            value={moment(
              detailRequestMoney?.timestamps?.dateOfTransaction
            ).format("DD/MM/YYYY")}
          /> */}
        </div>
        <div className="form-history-content border-top">
          <TextContent
            label="Order Time"
            value={moment(detailRequestMoney?.timestamps?.orderTime).format(
              "HH:mm:ss DD/MM/YYYY"
            )}
          />
        </div>
      </div>
      {detailRequestMoney?.status?.current === PaymentStatus.COMPLETED ||
        detailRequestMoney?.isPaid ? null : (
        <div
          className="form-history-button"
          style={{ paddingBottom: "10px", gap: 0 }}
        >
          <CustomButton
            size="large"
            text="Confirm"
            width={"100%"}
            onClick={handlePaid}
            isLoading={isLoadingUpdate}
          />
          <ButtonTransparent
            width={"100%"}
            size={"large"}
            onClick={() => {
              if (!isLoadingUpdate) handlePayLater();
            }}
            text={"Future date"}
            textClassName="text-button-back"
            disabled={isLoadingUpdate}
          />
        </div>
      )}
    </div>
  );
};

export default DetailSuccess;
